import React from 'react'
import { Tooltip } from 'antd'
import { InfoCircleFilled } from '@ant-design/icons'
import { showOverTime } from '../utils'
import './index.less'

export default function ({ actInfo = {} as TopInfo }) {
  return (
    <div className="tinfo">
      <div className="tinfo-title">
        <span className="tinfo-title_label">{actInfo.title}</span>
        <span className="tinfo-title_more">
          <Tooltip
            title={<div style={{ color: '#000' }} dangerouslySetInnerHTML={{ __html: actInfo.description }}></div>}
            color="#fff"
            placement="bottomLeft"
            overlayStyle={{ minWidth: '580px' }}
            overlayInnerStyle={{ maxHeight: '400px', overflow: 'auto' }}
          >
            <a href="javascript:;">详情</a>
          </Tooltip>
        </span>
      </div>
      <div className="tinfo-detail">
        <div className="tinfo-detail_l">
          <div className="tinfo-detail_l_num">
            <i>{actInfo.noMaterialsNum || 0}</i>
            <span>待完善商品素材数</span>
          </div>
          <div className="tinfo-detail_l_hint">
            &nbsp;&nbsp;
            <InfoCircleFilled />
            &nbsp;以下平台精选优质商品，请务必完善商品素材，完善结果将在所有活动下生效，完成后将有机会获得更多曝光机会和转化！
          </div>
        </div>
        <div className="tinfo-detail_r">
          <span className="tinfo-detail_r_label">剩余时间</span>
          <span
            className="tinfo-detail_r_time"
            dangerouslySetInnerHTML={{ __html: showOverTime(actInfo.endTimeStr).cutOffHint }}
          />
        </div>
      </div>
    </div>
  )
}
